import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.27.4/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var o;
import t from "react";
import { env as r } from '../utils/env.js';
import { useIsoMorphicEffect as d } from './use-iso-morphic-effect.js';
import { useServerHandoffComplete as f } from './use-server-handoff-complete.js';
var I = (o = t.useId) != null ? o : function () {
  var n = f(),
    _t$useState = t.useState(n ? function () {
      return r.nextId();
    } : null),
    _t$useState2 = _slicedToArray(_t$useState, 2),
    e = _t$useState2[0],
    u = _t$useState2[1];
  return d(function () {
    e === null && u(r.nextId());
  }, [e]), e != null ? "" + e : void 0;
};
export { I as useId };